import Layout from "../../Internal/Layout.vue";
import PromotionsCenter from "./PromotionsCenter.vue";
import Promotion from "./components/Promotion.vue";

const ResaleStockRoutes = {
  component: Layout,
  children: [
    {
      path: "/promotions-center-resale",
      name: "PromotionsCenterResale",
      component: PromotionsCenter,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
    {
      path: "/promotion-resale",
      name: "PromotionResale",
      component: Promotion,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresManagerial: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
  ],
};

export default ResaleStockRoutes;
